import { motion } from "framer-motion";
import { GOLD } from "./data";

export function Buy({ t }) {
  return (
    <motion.div initial={{ opacity: 0, scale: 0.8 }} animate={{ opacity: 1, scale: 1 }} transition={{ type: "spring", stiffness: 200, damping: 16 }}
      className="mx-auto max-w-sm rounded-2xl border border-emerald-400/40 bg-emerald-950/30 p-6 text-center" data-testid="engine-spot-buy">
      <div className="text-[10px] tracking-[0.3em] text-emerald-300">ORDER FILLED ON-CHAIN</div>
      <div className="mt-3 text-4xl font-black">BUY ${t.sym}</div>
      <div className="mt-2 text-sm text-white/60">sized to the pool · ${t.liq}k liquidity · confirmed in 1 block</div>
      <motion.div className="mt-5 h-1 rounded-full bg-emerald-400" initial={{ width: 0 }} animate={{ width: "100%" }} transition={{ duration: 1.6 }} />
    </motion.div>
  );
}

const PATH = (g) => {
  const pts = Array.from({ length: 24 }, (_, i) => {
    const x = (i / 23) * 400;
    const y = 150 - (i / 23) * Math.min(130, g) - Math.sin(i * 1.3) * 10 + (i < 4 ? 8 : 0);
    return `${i ? "L" : "M"}${x.toFixed(1)},${y.toFixed(1)}`;
  });
  return pts.join(" ");
};

export function Monitor({ t }) {
  return (
    <div className="mx-auto max-w-xl" data-testid="engine-spot-monitor">
      <div className="flex justify-between text-xs tracking-[0.25em] text-white/40 mb-2"><span>MONITORING ${t.sym}</span><span>STOP TRAILS UP</span></div>
      <svg viewBox="0 0 400 160" className="w-full h-44 rounded-2xl border border-white/10 bg-[#0a0a0a]">
        <motion.path d={PATH(t.gain)} fill="none" stroke={GOLD} strokeWidth="3" initial={{ pathLength: 0 }} animate={{ pathLength: 1 }} transition={{ duration: 4.4, ease: "easeInOut" }} />
        <motion.line x1="0" x2="400" stroke="#ef4444" strokeDasharray="6 6" strokeWidth="1.5" initial={{ y1: 155, y2: 155 }} animate={{ y1: 150 - Math.min(130, t.gain) * 0.55, y2: 150 - Math.min(130, t.gain) * 0.55 }} transition={{ duration: 4.4 }} />
      </svg>
      <div className="mt-3 grid grid-cols-3 gap-2 text-center text-[11px] text-white/50">
        <div>dev wallet: <span className="text-emerald-300">holding</span></div><div>pool: <span className="text-emerald-300">growing</span></div><div>smart money: <span className="text-emerald-300">adding</span></div>
      </div>
    </div>
  );
}

export function Sell({ t, cycle }) {
  return (
    <div className="text-center" data-testid="engine-spot-sell">
      <motion.div initial={{ scale: 0.4, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ type: "spring", stiffness: 180, damping: 12 }}
        className="text-6xl lg:text-7xl font-black" style={{ color: GOLD, textShadow: `0 0 40px ${GOLD}66` }} data-testid="engine-profit">+{t.gain}%</motion.div>
      <div className="mt-3 text-lg font-bold">SOLD ${t.sym}</div>
      <div className="mt-1 text-sm text-white/50">profit banked · cycle {cycle + 1} complete · next token loading…</div>
    </div>
  );
}
